export const ROUTES = {
  support: "/support",
} as const;
